import React, { useState } from 'react';
import usePlacesAutocomplete from '../Hooks/usePlacesAutocomplete';
import { StyledInput } from '../style';
export const SearchComponent = ({onPlaceSelected, onTextChange, input, enableSearch }) => {
  const { suggestions, loading, clearSuggestions } = usePlacesAutocomplete(enableSearch?input:'');
  
  function handleSelectPlace(s){
    onPlaceSelected(s)
    clearSuggestions()

  }
  return (
    <>
      <StyledInput
        type="text"
        placeholder="Buscar lugar..."
        value={input}
        name='direccion'
        onChange={onTextChange}
      />
      {loading && <p>Cargando...</p>}

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {enableSearch && (suggestions.map((s) => (
          <li
            key={s.placePrediction.placeId}
            style={{ cursor: 'pointer', margin: '5px 0', color: 'blue' }}
            onClick={() => handleSelectPlace(s)}
          >
            {s.placePrediction.text.text}
          </li>
        )))}
      </ul>

      
    </>
  );
};

export default SearchComponent;
